module.exports = __webpack_public_path__ + "static/img/ic_sale.f9cfc63.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ic_sale.png
// module id = VuyX
// module chunks = 2